








import { Vue, Component, Prop } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
@Component({})
export default class ShareMod extends Vue {
  @Prop() close: () => void
  @Prop() goodsUrl
  @Prop() goodsImg
  toBuy() {
    this.goodsUrl.indexOf('ivydadreadtool') === 0
      ? env.commonJump(this.goodsUrl)
      : (window.location.href = this.goodsUrl)
  }
}
